import React, { useEffect, useState } from "react";
import apiClient from "../services/apiClient";
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { Link } from 'react-router-dom';

const FavoritesPage = () => {
  const [favorites, setFavorites] = useState([]);

  useEffect(() => {
    apiClient
      .get("/api/v1/favorites")
      .then((response) => setFavorites(response.data))
      .catch((error) => console.error("Error fetching favorites:", error));
  }, []);

  return (
    <div>
      <h1>Favorite Stories</h1>
      
      { console.log(favorites) }
      <Box display="flex" flexWrap="wrap" justifyContent="space-between">
        {favorites.map((story, index) => (
          <Box key={index} width={{ xs: '100%', sm: '48%', md: '30%' }} mb={2}>
            <Paper elevation={3}>
              <Link to={`/stories/${story.id}`}>
                <h2>{story.name}</h2>
                <p>{story.description}</p>
              </Link>
            </Paper>
          </Box>
        ))}
      </Box>
    </div>
  );
};

export default FavoritesPage;